import { addDataLayerEntry } from '@printdeal/data-layer-manager';

const Event = {
  eec: 'gaEvent',
};

const Actions = {
  click: 'click',
  view: 'view',
};

/**
 * @param {String} id
 * @param {String} url
 * @param {String} Customer Service Page Name
 * @param {String} ContentFull ID
 * @return {*}
 */
export const dispatchDataLayerEventOnCSClick = (data: { navType: string }) => {
  const { navType } = data;
  addDataLayerEntry(Event.eec, {
    gaEvent: {
      eventCategory: navType,
      eventAction: Actions.click,
      eventNonInteraction: true,
    },
  });
};
